import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import {getNeighborhoods, getStreets} from "../../../../utils/location-utils.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { locationTypes, placeOptions, teams, sectors } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>
                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart ? new Date(filters.dtStart) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        loadOptions={getStreets}
                        value={filters.address}
                        isMulti={true}
                        isAsync={true}
                        wrapValues={true}
                        label={"Logradouro"}
                        onChange={(value) => setFilters(prev => ({...prev, address: value || ""}))}
                        cacheOptions
                        defaultOptions={[]}
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Local pré-cadastrado'
                        isMulti={true}
                        wrapValues={true}
                        options={placeOptions}
                        value={filters.place}
                        onChange={(value) => setFilters(prev => ({...prev, place: value}))}
                        instanceId="place"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        loadOptions={getNeighborhoods}
                        value={filters.neighborhood}
                        isMulti={true}
                        isAsync={true}
                        label={"Bairro"}
                        onChange={(value) => setFilters(prev => ({...prev, neighborhood: value}))}
                        cacheOptions
                        defaultOptions={[]}
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        isMulti={true}
                        value={filters.addressType}
                        options={locationTypes}
                        label={"Tipo de local"}
                        onChange={(value) => setFilters(prev => ({...prev, addressType: value}))}
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        isMulti={true}
                        label="Setor"
                        options={sectors}
                        value={filters.sectors}
                        onChange={(value) => setFilters(prev => ({...prev, sectors: value}))}
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        isMulti={true}
                        id="teams"
                        value={filters.teams}
                        options={teams ?? []}
                        label={"Equipe"}
                        onChange={(value) => setFilters(prev => ({...prev, teams: value}))}
                        classNameWrapper={"w-full"}
                    />
                </form>
            </div>
        </>
    );
};

export default Filters;